const selectsRefactor = () => {
  let $selects = document.querySelectorAll('select[auto-submit]')

  if($selects.length == 0) return

  $selects.forEach(($select) => {
    let $options = $select.querySelectorAll('option')
    if($options.length > 0) {
      $options.forEach(($option) => {
        if($option.value == 'all')
          $option.value = ''
      })
    }
  })

}

export default selectsRefactor
